import React from 'react'

import { getUser } from '@disco/state-management/selectors/user'

import ChargebeePricingEmbed from 'components/chargebee-pricing-embed'
import { ADMIN_ONLY_MESSAGE } from 'components/common/your-subscription/utils'
import { Text } from 'components/ds'
import PageContainer from 'components/ui/page-container'

import { useSelector } from 'hooks/use-redux'
import useReloadBusinessWhileVisible from 'hooks/use-reload-business-while-visible'

/** Lets an admin on a running Business or Artist trial choose a plan in Chargebee. */
const TrialSignup = (): React.ReactNode => {
  const user = useSelector(getUser)
  const isAdmin = Boolean(
    user.permissions?.includes('can_change_business_settings'),
  )

  // a non-admin can't check out, so has no payment to wait for
  useReloadBusinessWhileVisible(isAdmin)

  return (
    <PageContainer>
      {/* the backend refuses a non-admin the trial_signup pricing page */}
      {isAdmin ? (
        <ChargebeePricingEmbed />
      ) : (
        <Text as="p" size="2">
          {ADMIN_ONLY_MESSAGE}
        </Text>
      )}
    </PageContainer>
  )
}

export default TrialSignup
